import { UseForm } from "../../../../types/UseForm";
import { judicialProcedure } from "../abstractLitigationCase/fullFormDefinition";
import { overwriteFormElementField } from "../formDefinitionFunctions";
import { EmploymentContract } from "../../../../types/Products/EmploymentLaw/EmploymentContract";

export function overwriteJudicialProcedure(product: EmploymentContract) {
  const base = judicialProcedure(product);

  overwriteFormElementField(base.elements, `${product.productClassName}.principalClaim`, {
    isHidden: ({ values }: { values: UseForm["values"] }) =>
      values[product.productClassName].caseCategory !== "enforceClaim" ||
      ["lawsuitRevocation", "lawsuitRevocationBeforeHearing"].includes(product.lawsuitCompletedReason),
  });

  overwriteFormElementField(base.elements, `${product.productClassName}.principalClaimDefaultDate`, {
    isHidden: ({ values }: { values: UseForm["values"] }) =>
      values[product.productClassName].caseCategory !== "enforceClaim" ||
      ["lawsuitRevocation", "lawsuitRevocationBeforeHearing"].includes(product.lawsuitCompletedReason),
  });

  overwriteFormElementField(base.elements, `${product.productClassName}.accessoryClaim`, {
    isHidden: ({ values }: { values: UseForm["values"] }) =>
      values[product.productClassName].caseCategory !== "enforceClaim" ||
      ["lawsuitRevocation", "lawsuitRevocationBeforeHearing"].includes(product.lawsuitCompletedReason),
  });

  overwriteFormElementField(base.elements, `${product.productClassName}.accessoryClaimDefaultDate`, {
    isHidden: ({ values }: { values: UseForm["values"] }) =>
      values[product.productClassName].caseCategory !== "enforceClaim" ||
      ["lawsuitRevocation", "lawsuitRevocationBeforeHearing"].includes(product.lawsuitCompletedReason),
  });

  return base;
}
